import { createRoot, type Root } from "react-dom/client";
import Donate from "../pages/Donate/Donate";
import "../index.css";
import "../pages/Donate/Donate.custom.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) return;
  root = createRoot(element);
  root.render(<Donate />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADDonate = { mount, unmount };

function boot() {
  const element = document.getElementById("donate-root");
  if (element) mount(element);
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
else boot();
